/** Telas que usuários não administradores podem acessar (seção "Coletas" do menu e a documentação da API, sem menu). */
export const PAGINAS_NAO_ADMIN = ["/a/fechamento", "/a/graficos"];

/** Para onde o usuário não administrador vai ao entrar ou ao tentar abrir uma tela bloqueada. */
export const PAGINA_INICIAL_NAO_ADMIN = "/a/fechamento";

/** Grupo do menu visível para usuários não administradores. */
export const MENU_NAO_ADMIN = "coletas-fechamento";

export function podeAcessarPagina(pathname: string, isAdmin: boolean): boolean {
	if (isAdmin) {
		return true;
	}

	return PAGINAS_NAO_ADMIN.some((pagina) => pathname === pagina || pathname.startsWith(`${pagina}/`));
}
